var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoLogoMove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 24,
    viewBox: "0 0 126 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "31pmniwt9a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 37040",
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M0 0h126v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13664",
    d: "M61.584 22.611h.005l-.011-.005z",
    transform: "translate(-28.513 -10.834)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13665",
    d: "M64.434 22.611h.005l.005-.005z",
    transform: "translate(-29.835 -10.834)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 38351",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 38350",
    style: {
      clipPath: "url(#31pmniwt9a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13666",
    d: "M77.608 15.972h-2.373l-1.1 1.072a1.858 1.858 0 0 0-1.7-1.072h-2.354l-.939.907v-.907h-1.854v8.01h1.854V17.8h2.933a.35.35 0 0 1 .367.353v5.826h1.865V17.8h2.921a.36.36 0 0 1 .379.353v5.826h1.854V17.8a1.835 1.835 0 0 0-1.854-1.83",
    transform: "translate(-31.156 -7.682)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13667",
    d: "M99.492 15.973h-3.726a1.835 1.835 0 0 0-1.854 1.83v4.367a1.831 1.831 0 0 0 1.854 1.813h3.726a1.834 1.834 0 0 0 1.866-1.813V17.8a1.837 1.837 0 0 0-1.866-1.83m0 5.826a.364.364 0 0 1-.367.371h-2.98a.374.374 0 0 1-.379-.371v-3.639a.36.36 0 0 1 .379-.354h2.98a.35.35 0 0 1 .367.354z",
    transform: "translate(-43.484 -7.683)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13668",
    d: "m116.506 15.972-1.785 6.128-1.784-6.129h-2.076l2.455 8.01h2.81l2.46-8.01z",
    transform: "translate(-51.332 -7.683)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13669",
    d: "m131.669 19.063-.565 1.83h4.652V17.8a1.838 1.838 0 0 0-1.871-1.83h-3.72a1.835 1.835 0 0 0-1.854 1.83v4.37a1.831 1.831 0 0 0 1.854 1.813h4.664l.548-1.813h-4.834a.374.374 0 0 1-.379-.371v-3.643a.36.36 0 0 1 .379-.353h2.98a.345.345 0 0 1 .361.353v.907z",
    transform: "translate(-59.412 -7.683)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13670",
    d: "M156.39 15.972h-2.379l-1.1 1.072a1.859 1.859 0 0 0-1.7-1.072h-2.362l-.939.907v-.907h-1.854v8.01h1.854V17.8h2.933a.35.35 0 0 1 .367.353v5.826h1.866V17.8h2.921a.362.362 0 0 1 .384.353v5.826h1.854V17.8a1.838 1.838 0 0 0-1.854-1.83",
    transform: "translate(-67.632 -7.682)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13671",
    d: "m176.047 19.063-.56 1.83h4.647V17.8a1.837 1.837 0 0 0-1.867-1.83h-3.725a1.834 1.834 0 0 0-1.854 1.83v4.37a1.831 1.831 0 0 0 1.854 1.813h4.664l.549-1.813h-4.834a.374.374 0 0 1-.379-.371v-3.643a.36.36 0 0 1 .379-.353h2.98a.35.35 0 0 1 .367.353v.907z",
    transform: "translate(-79.96 -7.683)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13672",
    d: "M195.6 15.972h-2.36l-.945.907v-.907h-1.854v8.01h1.859V17.8h2.939a.345.345 0 0 1 .361.353v5.826h1.872V17.8a1.839 1.839 0 0 0-1.872-1.83",
    transform: "translate(-88.18 -7.682)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13673",
    d: "M209.3 20.159v-4h2.064l.565-1.83H209.3V12.52h-1.854v8.01a1.831 1.831 0 0 0 1.854 1.813h2.63V20.53h-2.25a.374.374 0 0 1-.379-.371",
    transform: "translate(-96.053 -6.043)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13674",
    d: "M225.056 19.063h-3.347a.371.371 0 0 1-.379-.353v-.553a.36.36 0 0 1 .379-.353h4.091l.565-1.83h-5.035a1.835 1.835 0 0 0-1.854 1.83v1.26a1.845 1.845 0 0 0 1.854 1.83h3.358a.361.361 0 0 1 .367.354v.552a.364.364 0 0 1-.367.371h-4.653l-.56 1.813h5.58a1.834 1.834 0 0 0 1.866-1.813v-1.278a1.848 1.848 0 0 0-1.866-1.83",
    transform: "translate(-101.624 -7.683)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13675",
    d: "M57.844 27.215a.418.418 0 0 0-.209.056l-.466.266a.4.4 0 0 0-.143.551.427.427 0 0 0 .564.142l.467-.266a.4.4 0 0 0 .143-.551.415.415 0 0 0-.355-.2",
    transform: "translate(-26.378 -13.022)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13676",
    d: "m10.212 32.286 1.876-1.06a1.445 1.445 0 0 0 .736-1.25V19.464l-2.611-1.488v2.671z",
    transform: "translate(-4.728 -8.634)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13677",
    d: "M34.862 19.48v10.5a1.447 1.447 0 0 0 .742 1.25l1.872 1.057v-14.3z",
    transform: "translate(-16.142 -8.639)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13678",
    d: "M43.618 1.127a.571.571 0 0 0 .577-.564.577.577 0 0 0-1.153 0 .571.571 0 0 0 .577.564",
    transform: "translate(-19.929 -.096)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13679",
    d: "m52.828 1.284.938-.536A.4.4 0 0 0 53.91.2a.419.419 0 0 0-.564-.142l-.937.536a.4.4 0 0 0-.188.246.388.388 0 0 0 .044.3.427.427 0 0 0 .564.142",
    transform: "translate(-24.173 -.096)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13680",
    d: "m3.209 15.095-.369-.207a1.918 1.918 0 0 0-1.9.007 1.914 1.914 0 0 0-.395.3A1.809 1.809 0 0 0 0 16.494v10.832a1 1 0 0 0 .515.877L4.94 30.7l.007-11.644v-2.971z",
    transform: "translate(0 -7.05)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13681",
    d: "m40.75 30.7 7.6-4.3a.4.4 0 0 0 .192-.245.386.386 0 0 0-.04-.306.417.417 0 0 0-.562-.149l-2.25 1.273v-2.115l2.61-1.512a.4.4 0 0 0 .19-.247.389.389 0 0 0-.045-.3.417.417 0 0 0-.564-.141l-2.189 1.27V16.5a1.832 1.832 0 0 0-.945-1.606 1.927 1.927 0 0 0-1.9-.006l-.037.021-2.06 1.176z",
    transform: "translate(-18.868 -7.05)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13682",
    d: "m21.423 10.044 2.335-1.314.04-.023a2.458 2.458 0 0 1 2.435.008 2.533 2.533 0 0 1 .295.2c.023.018.044.038.066.057a2.316 2.316 0 0 1 .195.179l.027.024a4.69 4.69 0 0 0-.7-1.708l-.154-.232 4.186-2.378a.4.4 0 0 0 .189-.244.391.391 0 0 0-.041-.307.421.421 0 0 0-.566-.143l-3.577 2.03a.964.964 0 0 1-1.295-.34.916.916 0 0 1 .189-1.153l2.066-1.2a.4.4 0 0 0 .188-.246.384.384 0 0 0-.043-.3.4.4 0 0 0-.251-.187.429.429 0 0 0-.316.044l-4.362 2.52a.993.993 0 0 1-.439.1.939.939 0 0 1-.805-.463.9.9 0 0 1 .246-1.193l.759-.447a.4.4 0 0 0 .192-.244.391.391 0 0 0-.043-.306.422.422 0 0 0-.569-.142l-6.762 3.887a2.848 2.848 0 0 1-2.787 0l-4.078-2.3a2.579 2.579 0 0 0-2.516 0l-2.9 1.632a4.974 4.974 0 0 0-2.431 3.3l.028-.026c.053-.054.11-.1.169-.153.029-.025.056-.051.087-.075a2.572 2.572 0 0 1 .25-.167c.013-.007.025-.017.038-.025A2.46 2.46 0 0 1 3.2 8.7l.355.2 2.018 1.135 3.149 1.766v.043l3.015 1.718a3.639 3.639 0 0 0 3.549 0l2.986-1.706v-.054z",
    transform: "translate(-.089 -1.323)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogoMove);
export default __webpack_public_path__ + "viewer/static/media/ico-logo-move.eb20bdd1a91ca651ab84dd1f692f59ae.svg";
export { ForwardRef as ReactComponent };